import styled from 'styled-components'

export const FadeOut = styled.div<{ state: string }>`
    opacity: ${({ state }) => (state === 'entering' || state === 'entered' ? 0 : 1)};
    transition: opacity 0.2s ease-in-out;
`
